<div class="app-timezone-picker__wrapper">
  <ng-select
    class="app-timezone-picker__panel"
    [items]="timeZones"
    [ngModel]="selectedZone"
    (ngModelChange)="onChange($event)"
    [clearable]="clearable"
    [virtualScroll]="virtualScroll"
    bindLabel="name"
    [placeholder]="customPlaceholderText"
    [notFoundText]="customNotFoundText"
    [disabled]="disabled"
    [appearance]="config.appearance"
    [appendTo]="config.appendTo"
    [clearOnBackspace]="config.clearOnBackspace"
    [closeOnSelect]="config.closeOnSelect"
    [dropdownPosition]="config.dropdownPosition"
    [hideSelected]="config.hideSelected"
  >
  </ng-select>
</div>
